import React, { useState, useEffect } from 'react';
import { ChefHat, Menu, X } from 'lucide-react';
import { Button } from '../ui';
import { NAV_LINKS } from '../../constants';

import logo from '../../assets/images/stoveShare.png';

const Navbar = ({ currentPage, onNavigate }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (page) => {
    onNavigate(page);
    setIsMenuOpen(false);
  };

  const scrollToWaitlist = () => {
    setIsMenuOpen(false);
    if (currentPage !== 'home') {
      onNavigate('home');
      setTimeout(() => {
        document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const NavLink = ({ link, mobile }) => {
    const cls = mobile
      ? 'block w-full text-left py-2 text-gray-700 hover:text-red-600 transition-colors font-medium'
      : 'text-gray-700 hover:text-red-600 transition-colors font-medium';

    if (link.page) {
      return (
        <button onClick={() => handleNav(link.page)} className={cls}>
          {link.label}
        </button>
      );
    }
    return (
      <a
        href={link.href}
        onClick={() => currentPage !== 'home' && handleNav('home')}
        className={cls}
      >
        {link.label}
      </a>
    );
  };

  return (
    <nav
      className={`
        fixed top-0 left-0 right-0 z-50
        border-b border-gray-200 shadow-sm
        transition-all duration-300
        ${isScrolled
          ? 'bg-gradient-to-br from-cyan-50 via-teal-50 to-emerald-50'
          : 'bg-gradient-to-br from-cyan-50/80 via-teal-50/80 to-emerald-50/80 backdrop-blur-md'
        }
      `}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">

          {/* Logo */}
          <button onClick={() => handleNav('home')} className="flex items-center space-x-2">
            <img
              src={logo}
              alt="StoveShare"
              className="w-8 h-8 object-contain rounded-full"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <ChefHat className="w-8 h-8 text-red-500 hidden" />
            <span className="text-2xl font-bold bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">
              StoveShare
            </span>
          </button>

          {/* Desktop links */}
          <div className="hidden md:flex items-center space-x-8">
            {NAV_LINKS.map((link) => (
              <NavLink key={link.label} link={link} />
            ))}
            <Button size="sm" onClick={scrollToWaitlist}>
              Join Waitlist
            </Button>
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-gradient-to-br from-cyan-50 via-teal-50 to-emerald-50 border-t border-gray-200 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            {NAV_LINKS.map((link) => (
              <NavLink key={link.label} link={link} mobile />
            ))}
            <Button className="w-full mt-2" onClick={scrollToWaitlist}>
              Join Waitlist
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;